import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiSearch, FiArrowUp, FiArrowDown, FiX } = FiIcons;

const FilterPanel = ({ columns, filters, onFilterChange }) => {
  const handleFilterUpdate = (key, value) => {
    onFilterChange({ ...filters, [key]: value });
  };

  const clearFilters = () => {
    onFilterChange({
      search: '',
      column: '',
      sortBy: '',
      sortOrder: 'ASC'
    });
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="bg-gray-50 p-4 rounded-lg mt-4"
    >
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {/* Search Column */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Search Column
          </label>
          <select
            value={filters.column}
            onChange={(e) => handleFilterUpdate('column', e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">Select column...</option>
            {columns.map((column) => (
              <option key={column} value={column}>
                {column}
              </option>
            ))}
          </select>
        </div>

        {/* Search Value */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Search Value
          </label>
          <div className="relative">
            <input
              type="text"
              value={filters.search}
              onChange={(e) => handleFilterUpdate('search', e.target.value)}
              placeholder="Enter search term..."
              className="w-full p-2 pl-8 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              disabled={!filters.column}
            />
            <SafeIcon 
              icon={FiSearch} 
              className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400" 
            />
          </div>
        </div>

        {/* Sort Column */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Sort By
          </label>
          <select
            value={filters.sortBy}
            onChange={(e) => handleFilterUpdate('sortBy', e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">No sorting</option>
            {columns.map((column) => (
              <option key={column} value={column}>
                {column}
              </option>
            ))}
          </select>
        </div>

        {/* Sort Order */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Sort Order
          </label>
          <div className="flex space-x-2">
            <button
              onClick={() => handleFilterUpdate('sortOrder', 'ASC')}
              className={`flex-1 p-2 rounded-md transition-colors flex items-center justify-center ${
                filters.sortOrder === 'ASC'
                  ? 'bg-blue-500 text-white'
                  : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
              }`}
              disabled={!filters.sortBy}
            >
              <SafeIcon icon={FiArrowUp} className="mr-1" />
              ASC
            </button>
            <button
              onClick={() => handleFilterUpdate('sortOrder', 'DESC')}
              className={`flex-1 p-2 rounded-md transition-colors flex items-center justify-center ${
                filters.sortOrder === 'DESC'
                  ? 'bg-blue-500 text-white'
                  : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
              }`}
              disabled={!filters.sortBy}
            >
              <SafeIcon icon={FiArrowDown} className="mr-1" />
              DESC
            </button>
          </div>
        </div>
      </div>

      {/* Clear Filters */}
      <div className="mt-4 flex justify-end">
        <button
          onClick={clearFilters}
          className="px-4 py-2 text-gray-600 hover:text-red-600 transition-colors flex items-center"
        >
          <SafeIcon icon={FiX} className="mr-1" />
          Clear Filters
        </button>
      </div>
    </motion.div>
  );
};

export default FilterPanel;